import axios from "axios";

export async function createTex() {
  return await axios.get(`/Tex/Create`);
}